







import { Vue, Component } from 'vue-property-decorator';
import { buildingOptions } from '../../../src_server/entity/master/buildingData';
@Component
export default class BuildingSelectBox extends Vue {
  building = 'co01';
  buildings: { value: string; title: string }[] = buildingOptions;

  created() {
    this.$emit('input', this.building);
  }

  onInput(e: any) {
    const value = (e.target as HTMLInputElement).value;
    this.$emit('input', value);
  }
}
